import {
  CITableGrid,
  Loader,
  NoDataAvailable,
  UnableToFetch
} from 'ccs-ui-components';
import classes from './AssociationList.module.scss';
import { IFooter } from './utils';

interface IAssociationList {
  headers: any;
  tableData: any;
  footer: IFooter;
  sorted: any;
  dataRowClick?: (row: any) => void;
  classNameBody?: string;
  errorMessage: string;
  isLoading: boolean;
  gridClass?: string;
}

const AssociationList = ({ headers = [], tableData, sorted = {}, footer = {}, dataRowClick = undefined, classNameBody = undefined, errorMessage, isLoading = false, gridClass = undefined }: Partial<IAssociationList>) => {
  const getUnableToFetch = () => {
    if (errorMessage?.length && !isLoading) {
      return (
        <div className={classes.page}>
          <UnableToFetch />
        </div>
      );
    }
    return null;
  };

  const getNoDataAvailable = () => {
    if (!errorMessage?.length && !isLoading && !tableData?.length) {
      return (
        <div className={classes.page}>
          <NoDataAvailable />
        </div>
      );
    }
    return null;
  };

  return (
    <>
      {getUnableToFetch()}
      {getNoDataAvailable()}
      <Loader show={isLoading} />
      {!errorMessage && tableData?.length !== 0 && (
        <div className={classes['association-list-table-data']}>
          <CITableGrid
            headers={headers}
            tableData={tableData}
            {...(sorted && { sorted })}
            {...(footer && { footer })}
            {...(dataRowClick && {
              dataRowClick: (row) => {
                dataRowClick(row);
              }
            })}
            {...(classNameBody && { classNameBody })}
            {...(gridClass && { className: gridClass })}
          />
        </div>
      )}
    </>
  );
};
export default AssociationList;
